import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnUser } from '../user';

export class FsBookmark extends SnModel {
  @Expose()
  public id: string;

  @Expose({ name: 'createdTimestamp' })
  @Type(() => Date)
  public createdTimestamp: Date;

  @Expose({ name: 'updatedTimestamp' })
  @Type(() => Date)
  public updatedTimestamp: Date;

  @Expose()
  public name: string;

  @Expose()
  public note: string;

  @Expose()
  public center: any;

  @Expose()
  public zoom: any;

  @Expose()
  public user: SnUser;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
